import React, { useRef } from 'react';
import styles from "./index.module.css"
import { useQrReader } from './useQrReader';
import ViewFinder from './ViewFinder';

export const ZxingQrReader = (props) => {

  const {
    facingMode,
    scanDelay,
    onError,
    onResult,
    active
  } = props

  const videoRef = useRef()

  useQrReader({
    facingMode,
    scanDelay,
    onResult,
    onError,
    videoRef,
    active
  });

  return (
    <div className={styles.container}>
      <ViewFinder/>
      <video
        muted
        ref={videoRef}
        className={styles.video}
        style={{transform: facingMode === 'user' ? 'scaleX(-1)' : undefined}}
      />
    </div>
  );
};

export default ZxingQrReader;
